import { ROUTE_PATH, localStorageService, toastFail } from '../helpers'
import {
  ROLE_BUYER,
  ROLE_SUPPLIER,
  ROLE_ADMIN,
  ROLE_BUYER_ADMIN,
} from '../store/role/constants'

const refreshTokenPath = {
  ADMIN: '/auth/token/refresh',
  BUYER: '/auth/buyer/token/refresh',
  SUPPLIER: '/auth/supplier/token/refresh',
}

const matchPath = str => {
  return window.location.hostname.indexOf(str) > -1
}

export const getWebRole = () => {
  return localStorage.getItem('web_role')
}

export const handleRole = (
  roleSelect = localStorage.getItem('web_role') || ROLE_BUYER
) => {
  if (matchPath('buyer_admin')) {
    roleSelect = ROLE_BUYER_ADMIN
  } else if (matchPath('buyer')) {
    roleSelect = ROLE_BUYER
  } else if (matchPath('supplier')) {
    roleSelect = ROLE_SUPPLIER
  } else if (matchPath('admin')) {
    roleSelect = ROLE_ADMIN
  }

  if (roleSelect) {
    localStorage.setItem('refresh_url', refreshTokenPath[roleSelect])
    localStorage.setItem('web_role', roleSelect)
  }

  return roleSelect
}

export const getRefreshTokenPath = () => {
  const roleSelect = handleRole()
  return refreshTokenPath[roleSelect]
}

export const useAuthUtil = history => {
  const loginFlow = res => {
    if (res.status === 'InActivate') {
      history.push(ROUTE_PATH.CONTACT_ADMIN.LINK)
    } else if (res.status === 'NotActivate') {
      toastFail(
        'Your account has not activated. Please click "Forgot password" to activate.'
      )
    } else {
      console.log({ res })
      const { id, full_name, email, roles, company_id } = res
      const storageService = localStorageService.getService()

      storageService.setUsersName(full_name)
      localStorage.setItem('email', email)
      localStorageService.setCompanyId(company_id)
      localStorageService.setBuyerId(id)

      const userData = JSON.stringify(roles)

      if (typeof userData !== 'undefined' && userData !== 'undefined') {
        localStorage.setItem('userData', userData)
      } else {
        const roleSupAdmin = [{ id: 5, name: 'SupplierAdmin' }]
        const userData = JSON.stringify(roleSupAdmin)
        localStorage.setItem('userData', userData)
      }

      storageService.setToken(res)
      sessionStorage.setItem('email', email)
      localStorage.setItem('role', res.role)

      if (res.company) {
        localStorage.setItem('logo', res.company.logo)
      }

      // redirect them to WIDGETS!
      const itemSupManagement = localStorageService.getSupplierManagement()
      const idProject = localStorage.getItem('idProject')
      const rfqid = localStorage.getItem('rfqid')
      const eventType = localStorage.getItem('eventType')
      // const itemSourcingCompare = localStorageService.getSourcingCompare()
      const itemSourcingDetail = localStorageService.getSourcingDetail()
      const tokenCheck = localStorageService.getTokenCheckFromEmail()

      if (itemSupManagement) {
        const url = `/supplier-management-information-edit:${itemSupManagement}`
        history.replace(url)
      } else if (idProject && rfqid) {
        const url = `sourcing-compare-events/${idProject}/${rfqid}/${eventType}`
        history.replace(url)
      } else if (itemSourcingDetail) {
        let url
        if (tokenCheck) {
          url = `/sourcing-detail-form-supplier/${itemSourcingDetail}?token=${tokenCheck}`
        } else {
          url = `/sourcing-detail-form-supplier/${itemSourcingDetail}`
        }
        history.replace(url)
      } else {
        history.replace(ROUTE_PATH.HOME.LINK)
      }
    }
  }

  const redirectFromMail = (goto, link = '', user = {}) => {
    // console.log(link, user)
    if (user.id && link.includes('/login/')) {
      goto(link.replace('/login', ''))
    }
  }

  const isRegisterPath = path => {
    return path.includes('supplier-registration-form')
  }

  return {
    handleRole,
    loginFlow,
    redirectFromMail,
    isRegisterPath,
  }
}
